import React from 'react';
import { Check, X, Star } from 'lucide-react';
import { Section, CTAButton } from './Shared';
const REFLEXO_HREF = 'https://www.lumenakasha.com/cart/46722804678845:1';
const ACELERADOR_HREF = 'https://www.lumenakasha.com/cart/46787506733245:1';
const rows = [{
  feature: 'Tomo Principal REFLEXO-PRO',
  plan1: true,
  plan2: true
}, {
  feature: 'Bonus 1: El Legajo de Campo',
  plan1: true,
  plan2: true
}, {
  feature: 'Bonus 2: El Control de Abastecimiento',
  plan1: true,
  plan2: true
}, {
  feature: 'Bonus 3: Pack de Tarjetas Post-Sesión',
  plan1: true,
  plan2: true
}, {
  feature: 'Acelerador de Consultorio',
  plan1: false,
  plan2: true
}, {
  feature: 'Guiones de WhatsApp listos para usar',
  plan1: false,
  plan2: true
}, {
  feature: 'Sistema de paquetes y precios',
  plan1: false,
  plan2: true
}, {
  feature: 'Protocolo de Cierre en Camilla',
  plan1: false,
  plan2: true
}, {
  feature: 'Estrategia de Instagram',
  plan1: false,
  plan2: true
}];
const Cell = ({
  included
}: {
  included: boolean;
}) => included ? <Check className="w-5 h-5 md:w-6 md:h-6 text-brand-green mx-auto" data-id="element-306" /> : <X className="w-5 h-5 md:w-6 md:h-6 text-brand-text/30 mx-auto" data-id="element-307" />;
export const Pricing = () => {
  return <Section id="pricing" className="bg-brand-surfaceLight/30 rounded-3xl my-12" data-id="element-308">
      <div className="text-center mb-10 md:mb-12" data-id="element-309">
        <h2 className="text-2xl md:text-4xl font-serif font-bold" data-id="element-310">
          ¿CON CUÁL TE QUEDÁS?
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-311">
        <div className="glass-panel rounded-3xl overflow-hidden border-brand-pink/30 bg-white/85" data-id="element-312">
          {/* Header */}
          <div className="grid grid-cols-[1.4fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr]" data-id="element-313">
            <div className="p-4 md:p-6 bg-brand-surfaceLight/40 border-b border-brand-pink/20" data-id="element-314"></div>
            <div className="p-3 md:p-6 text-center bg-brand-surfaceLight/60 border-b border-l border-brand-pink/20" data-id="element-315">
              <p className="font-serif font-bold text-sm md:text-lg text-brand-text leading-tight" data-id="element-316">
                KIT
                <br className="md:hidden" data-id="element-317" /> REFLEXO-PRO
              </p>
            </div>
            <div className="p-3 md:p-6 text-center bg-brand-rose/10 border-b border-l border-brand-pink/20 relative" data-id="element-318">
              <div className="absolute top-1 left-1/2 -translate-x-1/2 bg-brand-rose text-white text-[9px] md:text-[10px] font-bold px-2 py-0.5 rounded-full flex items-center gap-0.5 whitespace-nowrap" data-id="element-319">
                <Star className="w-2.5 h-2.5 fill-current" data-id="element-320" />
                MÁS ELEGIDO
              </div>
              <p className="font-serif font-bold text-sm md:text-lg text-brand-rose leading-tight mt-3 md:mt-2" data-id="element-321">
                KIT
                <br className="md:hidden" data-id="element-322" /> ACELERADOR
              </p>
            </div>
          </div>

          {/* Rows */}
          {rows.map((row, i) => <div key={i} className="grid grid-cols-[1.4fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr] border-b border-brand-pink/15 last:border-0" data-id="element-323">
              <div className="p-3 md:p-5 text-xs md:text-sm text-brand-text/90 font-medium" data-id="element-324">
                {row.feature}
              </div>
              <div className="p-3 md:p-5 flex items-center justify-center border-l border-brand-pink/15" data-id="element-325">
                <Cell included={row.plan1} data-id="element-326" />
              </div>
              <div className="p-3 md:p-5 flex items-center justify-center border-l border-brand-pink/15 bg-brand-rose/5" data-id="element-327">
                <Cell included={row.plan2} data-id="element-328" />
              </div>
            </div>)}

          {/* Price row */}
          <div className="grid grid-cols-[1.4fr_1fr_1fr] md:grid-cols-[2fr_1fr_1fr] bg-brand-surfaceLight/50 border-t border-brand-pink/30" data-id="element-329">
            <div className="p-3 md:p-5 font-serif font-bold text-sm md:text-lg text-brand-text" data-id="element-330">
              Precio
            </div>
            <div className="p-3 md:p-5 text-center border-l border-brand-pink/20" data-id="element-331">
              <span className="font-serif font-bold text-base md:text-2xl text-brand-text" data-id="element-332">
                $19.990
              </span>
            </div>
            <div className="p-3 md:p-5 text-center border-l border-brand-pink/20 bg-brand-rose/10" data-id="element-333">
              <span className="font-serif font-bold text-base md:text-2xl text-brand-rose" data-id="element-334">
                $27.990
              </span>
            </div>
          </div>

          {/* CTAs row */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 p-4 md:p-6 bg-white/60 border-t border-brand-pink/20" data-id="element-335">
            <CTAButton fullWidth className="text-xs md:text-sm py-3 md:py-4" href={REFLEXO_HREF} data-id="element-336">
              🦶 → LO QUIERO $19.990
            </CTAButton>
            <CTAButton fullWidth className="text-xs md:text-sm py-3 md:py-4 animate-pulse-slow" href={ACELERADOR_HREF} data-id="element-337">
              ⭐ → LO QUIERO $27.990
            </CTAButton>
          </div>
        </div>
      </div>
    </Section>;
};